import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { TransitionGroup } from 'react-transition-group';

import CssTransition from '../../components/Transition/CssTransition';
import TransitionGroupContainer from '../../components/Transition/TransitionGroupContainer';

import CheckRegistrationStart from './CheckRegistrationStart';
import CheckRegistrationDetails from './CheckRegistrationDetails';
import CheckRegistrationSuccess from './CheckRegistrationSuccess';

const CheckRegistration = () => (
    <Route
        render={({ location }) => (
            <TransitionGroup component={TransitionGroupContainer}>
                <CssTransition key={location.key} timeoutInMs={650}>
                    <Switch location={location}>
                        <Route
                            path="/(checkRegistration|checkRegistration/start)"
                            name="CheckRegistrationStart"
                            exact
                            component={CheckRegistrationStart}
                        />
                        <Route
                            path="/checkRegistration/details"
                            name="CheckRegistrationDetails"
                            exact
                            component={CheckRegistrationDetails}
                        />
                        <Route
                            path="/checkRegistration/success"
                            name="CheckRegistrationSuccess"
                            exact
                            component={CheckRegistrationSuccess}
                        />
                    </Switch>
                </CssTransition>
            </TransitionGroup>
        )}
    />
);

export default CheckRegistration;



// WEBPACK FOOTER //
// ./src/containers/CheckRegistration/CheckRegistration.jsx